/**
 * Generic helper used to consolidate all call sites for getting a cell id into
 * one method. The strategy currently is that a "cellId" is just the combination
 * of the row id and the header key used to access this field in a row.
 *
 * @param {string} rowId
 * @param {string} header
 * @returns {string}
 */
export var getCellId = function getCellId(rowId, header) {
  return "".concat(rowId, ":").concat(header);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/DataTable/tools/cells.js
// module id = 304
// module chunks = 0